import React from "react";
import { LogoManager } from "../LogoManager";

interface LogoSectionProps {
    useLogo: boolean;
    hasLogo: boolean;
    onLogoChange: (hasLogo: boolean) => void;
    onUseLogoToggle: (use: boolean) => void;
}

export const LogoSection: React.FC<LogoSectionProps> = ({
    useLogo,
    hasLogo,
    onLogoChange,
    onUseLogoToggle
}) => {
    return (
        <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-4 sm:p-6">
            <h3 className="text-lg font-medium mb-3 sm:mb-4">Company Logo</h3>

            <div className="mb-4">
                <LogoManager onLogoChange={onLogoChange} />
            </div>

            <div className="flex items-center mt-4">
                <label className="relative inline-flex items-center cursor-pointer">
                    <input
                        type="checkbox"
                        className="sr-only peer"
                        checked={useLogo}
                        onChange={() => onUseLogoToggle(!useLogo)}
                        disabled={!hasLogo}
                    />
                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                    <span className="ml-3 text-sm font-medium text-gray-700 dark:text-gray-300">
                        Use my logo on the invoice
                    </span>
                </label>
            </div>

            {!hasLogo && (
                <p className="text-sm text-gray-500 mt-2">
                    Upload a logo above to use it on your invoice.
                </p>
            )}
        </div>
    );
};
